import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "users" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "type-data" }
const _hoisted_7 = { class: "emq-table-footer" }

import { getCardList, banCard, deleteCard } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { ElMessage, ElMessageBox } from 'element-plus'
import AdosBrief from '@/components/AdosBrief.vue'
import CardType from '@/components/CardType.vue'
import { IdType } from '@/types/types'
import { dateFormat, throttleBtn } from '@/common/tools'
import UserBindEvse from './components/UserBindEvse.vue'
import CardUpsert from './components/CardUpsert.vue'
import SelectOperator from '@/components/SelectOperator.vue'
import { checkMenuShow } from '@/store/tool'
import LinkEvse from '@/components/Links/LinkEvse.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import LinkStation from '@/components/Links/LinkStation.vue'
import LinkUser from '@/components/Links/LinkUser.vue'

import { defineComponent, ref, defineProps } from 'vue'

const __default__ = defineComponent({
  name: 'Cards',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  hideFilter: {
    type: Boolean,
    default: () => false,
  },
  operatorID: {
    type: String,
    default: () => '0',
  },
  evseID: {
    type: String,
    default: () => '0',
  },
},
  setup(__props) {

const props = __props



const { t } = useI18nTl('Operation')

const showCard = ref({})
const showDialogIsEdit = ref(false)
const showDialog = ref(false)
const showBindDialog = ref(false)
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { enableSelects, evseStateSelects } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const addCardDialog = () => {
  showCard.value = {}
  showDialogIsEdit.value = false
  showDialog.value = true
}

const editCardDialog = (row: any) => {
  showCard.value = row
  showDialogIsEdit.value = true
  showDialog.value = true
}

const deleteCardDialog = async (row: any) => {
  try {
    await ElMessageBox.confirm(t('Operation.deleteCardConfirm') + row.cardNo + ' ?', {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })
    let res = await deleteCard(row.id)
    if (res) {
      ElMessage.success(t('Base.removeSuccess'))
      loadCards()
    }
  } catch (error) {
    console.error(error)
  }
}

const handleSwitchStatus = async (row: any) => {
  try {
    await banCard(row.id, !row.ban)
    if (!row.ban) {
      ElMessage.success(t('Base.disabledSuccess'))
    } else {
      ElMessage.success(t('Base.enableSuccess'))
    }
    await handleSearch()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadCards()
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { No, operatorID, enable } = params
  newParams = {
    No: No || undefined,
    operatorID: operatorID || undefined,
    enable: enable || undefined,
  }
  return newParams
}

const loadCards = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }
  if (props.evseID != '0') {
    sendParams.evseID = props.evseID
    sendParams.getLocalFlag = true
  }

  try {
    const { list = [], pageReply = {} } = await getCardList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    // tableData.value = list
    tableData.value = list.map((item: any) => ({
      ...item,
      showEnable: !item.ban,
    }))
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadCards)
loadCards()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.hideFilter)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "search-wrapper",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: fuzzyParams.value.No,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.No) = $event)),
                      placeholder: _ctx.$t('Operation.cardNo'),
                      clearable: "",
                      onClear: handleSearch
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: fuzzyParams.value.enable,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.enable) = $event)),
                      placeholder: _ctx.$t('Base.isEnabled'),
                      clearable: "",
                      onClear: handleSearch
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enableSelects), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectOperator, {
                      modelValue: fuzzyParams.value.operatorID,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.operatorID) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                (showMoreQuery.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      icon: _unref(Search),
                      onClick: handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshLeft),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onKeyup"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addCardDialog()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'driverCardUpsert']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "account",
            "min-width": "80",
            label: _ctx.$t('Operation.cardNo'),
            show: "false",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                placement: "top",
                content: row.id
              }, {
                default: _withCtx(() => [
                  (_unref(checkMenuShow)('driverCardUpsert'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "text",
                        onClick: ($event: any) => (editCardDialog(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.cardNo), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.cardNo), 1))
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "cardType",
            "min-width": "100",
            label: _ctx.$t('Operation.cardType')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(CardType, {
                type: row.cardType
              }, null, 8, ["type"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "80",
            label: _ctx.$t('Operation.operator'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkOperator, {
                id: row.operatorID,
                name: row.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "stationName",
            "min-width": "80",
            label: _ctx.$t('Operation.station'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkStation, {
                id: row.id,
                name: row.name
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "sn",
            "min-width": "80",
            label: _ctx.$t('Evses.equipment'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkEvse, {
                id: row.evseID,
                name: row.sn
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "userName",
            "min-width": "80",
            label: _ctx.$t('Operation.user'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkUser, {
                id: row.userID,
                name: row.userName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "showEnable",
            label: _ctx.$t('Base.enable')
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives(_createVNode(_component_el_switch, {
                modelValue: row.showEnable,
                "onUpdate:modelValue": ($event: any) => ((row.showEnable) = $event),
                onChange: ($event: any) => (handleSwitchStatus(row))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), [
                [_directive_role, 'driverCardBan']
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "ban",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              (
                row.cardType == _unref(IdType).IT_ONLINE_IDENTITY_CARD && _unref(checkMenuShow)('driverCardUpsert')
              )
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    plain: "",
                    onClick: ($event: any) => (editCardDialog(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (
                row.cardType == _unref(IdType).IT_LOCAL_IDENTITY_CARD && _unref(checkMenuShow)('driverCardDelete')
              )
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "small",
                    plain: "",
                    onClick: ($event: any) => (deleteCardDialog(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[4] || (_cache[4] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadCards
        }, null, 8, ["metaData"])
      ]),
      _createVNode(CardUpsert, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
        cardInfo: showCard.value,
        operatorID: props.operatorID,
        evseID: props.evseID,
        "is-edit": showDialogIsEdit.value,
        onlyLocalCard: props.hideFilter,
        onSubmitted: loadCards
      }, null, 8, ["modelValue", "cardInfo", "operatorID", "evseID", "is-edit", "onlyLocalCard"])
    ])
  ]))
}
}

})